var map = {
	"./project1.png": 6291,
	"./project10.png": 6507,
	"./project11.png": 9026,
	"./project12.png": 5113,
	"./project2.png": 4312,
	"./project3.png": 6353,
	"./project4.png": 8142,
	"./project5.png": 3927,
	"./project6.png": 6892,
	"./project7.png": 8517,
	"./project8.png": 9362,
	"./project9.png": 907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9245;